import {
  DescriptionRunEventDTO,
  DescriptionRunResultDTO,
  DescriptionRunResultDTOStatusEnum,
  GetDescriptionRunEventsActionEnum
} from "@app/api/generated";
import { EVENTS_PAGE_SIZE, getRunById, getRunEvents } from "@app/api/product-description-api";
import { IRunDetailSource } from "@app/util/use-run-detail";

/** What the shared run-detail hook needs to show a description run. */
export const DESCRIPTION_RUN_DETAIL_SOURCE: IRunDetailSource<
  DescriptionRunResultDTO,
  DescriptionRunEventDTO,
  GetDescriptionRunEventsActionEnum
> = {
  getRun: getRunById,
  getEvents: getRunEvents,
  eventsPageSize: EVENTS_PAGE_SIZE,
  isRunning: (run) => run.status === DescriptionRunResultDTOStatusEnum.RUNNING
};
